import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { Space } from '@client/components/_ui/layout/Space';
import { useConfirmModalStore } from '@client/stores/confirmModalStore';
import { Modal } from 'antd';
import { CircleAlert } from 'lucide-react';

export function ConfirmModal() {
    const { isOpen, isLoading, options, hide, setIsLoading } = useConfirmModalStore();

    if (!options) {
        return null;
    }

    function handleCancel() {
        if (isLoading) {
            return;
        }

        options?.onCancel?.();
        hide();
    }

    return (
        <Modal
            open={isOpen}
            zIndex={2000}
            title={
                <span className="flex items-center gap-2">
                    {options.icon ?? <CircleAlert className="text-status-warning" size={20} />}
                    {options.title}
                </span>
            }
            // Lock the modal while the async action runs — no ESC, mask-click or close-button dismiss.
            keyboard={!isLoading}
            mask={{ closable: !isLoading }}
            closable={!isLoading}
            width={options.width}
            onCancel={handleCancel}
            footer={
                <Space>
                    <Button type="secondary" disabled={isLoading} onClick={handleCancel}>
                        {options.cancelText ?? 'Cancel'}
                    </Button>
                    <Button
                        type={options.okDanger ? 'danger-filled' : 'primary'}
                        loading={isLoading}
                        onClick={async () => {
                            if (!options.onOk) {
                                hide();
                                return;
                            }

                            setIsLoading(true);

                            try {
                                await options.onOk();
                                hide();
                            } catch {
                                // Keep the modal open so the user can retry; the caller is responsible
                                // for surfacing the error (matches antd's built-in Modal.confirm behavior).
                                setIsLoading(false);
                            }
                        }}
                    >
                        {options.okText ?? 'OK'}
                    </Button>
                </Space>
            }
        >
            {options.content}
        </Modal>
    );
}
